import { ProcessesHome } from "./ProcessesHome";
import { ProcessesCategoriesList } from "./ProcessesCategoriesList";
import { ProcessDetail } from "./ProcessDetail";
import { ProcessesList } from "./ProcessesList";
import { Record } from "../components/record/Record";
import { EntityForm } from "../components/entityForm/EntityForm";
import { processesOptions } from "./processesOptions";

const fieldsQuery =
    "*.*,responsibles_role.directus_roles_id.name,supervisores_role.directus_roles_id.name,shared_roles.directus_roles_id.name";

export const processesRoutes = [
    {
        path: "/processes",
        element: <ProcessesHome />,
    },
    {
        path: "/processes/parentcategory/:parentcategoryid",
        element: <ProcessesCategoriesList  />,
    },
    {
        path: "/processes/parentcategory/:parentcategoryid/category/:categoryid",
        element: <ProcessesList />,
    },
    {
        path: "/processes/parentcategory/:parentcategoryid/category/:categoryid/:processid",
        element: <ProcessDetail />,
    },
    {
        path: "/processes/:id/update",
        element: (
            <Record
                entity="processes"
                type="update"
                fieldsQuery={fieldsQuery}
                body={<EntityForm groupsOptions={processesOptions.groupsOptions} />}
            />
        ),
    },
    {
        path: "/processes/create",
        element: (
            <Record
                entity="processes"
                type="create"
                fieldsQuery={fieldsQuery}
                body={<EntityForm groupsOptions={processesOptions.groupsOptions} />}
            />
        ),
    },
];
